import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageSwitchService {
  public static readonly availableLanguages: string[] = ['id', 'en'];
  platformId = inject(PLATFORM_ID);

  /**
   * Single source of truth for the localStorage key that persists the active
   * language. Read and written only through this service so the initial-load
   * restoration and the live switch stay in sync.
   */
  public static readonly storageKey = 'lang';

  public static readonly defaultLanguage: string = LanguageSwitchService.availableLanguages[0];

  private translateService: TranslateService = inject(TranslateService);

  public initLanguageFromLocalStorage(): void {
    if (isPlatformBrowser(this.platformId)) {
      const languageFromStorage: string | null = localStorage.getItem(LanguageSwitchService.storageKey);
      if (
        languageFromStorage &&
        LanguageSwitchService.availableLanguages.includes(languageFromStorage)
      ) {
        this.setLanguage(languageFromStorage);
      }
    }

  }

  public getCurrentLanguage(): string {
    if (
      this.translateService.currentLang &&
      this.translateService.currentLang !== LanguageSwitchService.defaultLanguage
    ) {
      return this.translateService.currentLang;
    }
    return LanguageSwitchService.defaultLanguage;
  }

  public setLanguage(languageId: string): void {
    if (isPlatformBrowser(this.platformId)) {
      if (LanguageSwitchService.availableLanguages.includes(languageId)) {
        this.translateService.use(languageId);
        localStorage.setItem(LanguageSwitchService.storageKey, languageId);
      }
    }
  }
}
